export const Config = {
    data: {},
    date: {
        patterns: {
            de: "DD.MM.YYYY",
            en: "YYYY-MM-DD",
        },
        i18n: {
            de: {
                firstDay: 1,
                previousMonth: "Vorheriger Month",
                nextMonth: "Nächster Monat",
                months: [
                    "Januar",
                    "Februar",
                    "März",
                    "April",
                    "Mai",
                    "Juni",
                    "Juli",
                    "August",
                    "September",
                    "Oktober",
                    "November",
                    "Dezember",
                ],
                weekdays: [
                    "Sonntag",
                    "Montag",
                    "Dienstag",
                    "Mittwoch",
                    "Donnerstag",
                    "Freitag",
                    "Samstag",
                ],
                weekdaysShort: ["So", "Mo", "Di", "Mi", "Do", "Fr", "Sa"],
            },
        },
    },
    html: {
        allowed: [
            "a",
            "i",
            "b",
            "small",
            "smaller",
            "strong",
            "em",
            "div",
            "p",
            "article",
            "section",
            "ul",
            "ol",
            "li",
            "h1",
            "h2",
            "h3",
            "h4",
            "h5",
            "h6",
            "hr",
            "br",
            "span",
        ],
    },
    sentry: {
        ignore: [
            "null",
            "timeout",
            '{"code":0}',
            "Berechtigung",
            "rpc.buchung-repo.extern-get-buchung",
            "unbekannte agentur-nr",
            "Unbekannte BN",
            "mit sich selbst",
            "bereits miteinander",
            "zeitlich nicht überschneiden",
            "zeitlich mit einem anderen Termin",
            "canceled",
            "excluded",
            "not-found",
            "unauthorized",
            "ERR__UNVERIFIED_JWT",
            "ERR__INVALID_PHONENUMBER",
            "ERR__EXCEPTION_IN_SERVICEFN",
            "ERR__TWO_FACTOR_AUTH_NO_CODE",
            "ERR__FEHLENDE_BUCHUNGS_BERECHTIGUNG",
            "gtag",
            "b.container[a]",
            "reading '360410'",
            "Illegal invocation",
            "QuotaExceededError",
            "Unexpected end of input",
            "Unexpected token 'else'",
            "MethodName:soundPlayingChanged",
            "getRestrictions is not a function",
            "MethodName:browserNotificationOpenUi",
            'redefine non-configurable property "userAgent"',
            "Identifier 'change_ua' has already been declared",
            "Object doesn't support property or method 'includes'",
            "SyntaxError: No identifiers allowed directly after numeric literal",
        ],
    },
};
export default Config;
